import jwtDecode from "jwt-decode";
import log from "../sitel/commons/services/log";
import http from "../sitel/commons/services/http";
import md5 from "md5";

//TODO delete? const homeFolder = process.env.REACT_APP_HOME_FOLDER;

let tokenKey = '';
let client_id = '';
let oauth_server = '';
let client_redirect_uri = '';
let scopes = '';
const code_challenge = 'sdfgkjjhdsfkjhasdfkljhf324534~.DFGSDFsdfgkjjhdsfkjhasdfkljhf324534~.DFGSDF';
let logout_url = '';
let User = null;
let onUserChange = ()=>{};

export function setOnUserChange(handler){
  onUserChange=handler;
}
//simple hide password when submitted
//For now , return the password, latrer implement SPR (or how ever they call this algoritem)
export function perculator(str){
  return md5(str);
};

/**
 * PUBLIC
 * @param {*} app_name 
 */
function setTokenKeyName(app_name) {
  tokenKey = app_name;
}

/**
 * PUBLIC
 * @param {*} app_name 
 */
function setOauth(i_client_id, i_oauth_server, i_client_redirect_uri,i_scopes,i_base_logout/*TODO needs to come from server ,i_code_challenge*/) {
  client_id = i_client_id;
  oauth_server = i_oauth_server;
  client_redirect_uri = i_client_redirect_uri;
  scopes = i_scopes;
  logout_url = i_base_logout + '?client_id=' + i_client_id;
  //TODO needs to come from server code_challenge = i_code_challenge;
}

export function getOauthLink(originApp) {
  const oauth_url = `${oauth_server}?state=${originApp}&scope=${scopes}&response_type=code&approval_prompt=auto&redirect_uri=${client_redirect_uri}` +
                     `&client_id=${client_id}&code_challenge=${code_challenge}`; //&code_challenge_method=S256

  return oauth_url;
}

/****************** JWT *****************/
function setJWT(jwt) {
  http.setJwt(jwt);
  localStorage.setItem(tokenKey, jwt);
}

function getJwt() {
  const jwt = localStorage.getItem(tokenKey);
  http.setJwt(jwt);
  return jwt;
}

function removeJwt() {
  return localStorage.removeItem(tokenKey);
}

function parseJWT(encoded_jwt){
  log.debug('parseJWT');
  let tempUser = null;
  try{
      const AccessToken = jwtDecode(encoded_jwt);
      log.debug('ACCESS TOKEN PARSED:',AccessToken);

      //JWT always coming from DemonHead, even if initial JWT came from Opal, DemonHead will normalize it
      //and load all user info. Opal is used just to auth.
      if(AccessToken.user){
        tempUser = AccessToken.user;
      }else{
        throw Error('Bad access token');
      }
      log.debug('(2)USER IS ',tempUser);
      return tempUser;
  } catch (ex) {
    log.fatal("EXCEPTION!", ex);
  }
}

function loginWithJwt(encoded_jwt) {
  log.debug('loginWithJwt');
  User=parseJWT(encoded_jwt);
  setJWT(encoded_jwt);
  onUserChange(User);
}

/**
 * 
 * @param {*} code 
 * @param {*} extraParams 
 * @param {*} usp (user name password)
 * @returns 
 */
async function loadJWTFromServer(code,extraParams='',usp={}) {
  log.debug('loadJWTFromServer');
  try{
    const {data:{payload:{access_token}}} = await http.post(`/opal?code=${code}&code_challenge=${code_challenge}${extraParams}`,usp);
    //server will get the token and return to the app the JWT of the user OR a unauthorized, if user has no role in this system
    loginWithJwt(access_token);
  } catch(error){
    console.error('loadJWTFromServer Error',error);
    return false
  }
  return true;
}

function localLogout() {
  removeJwt();
  window.location.href = logout_url;
}

function logoutWithoutRedirect() {
  removeJwt();
}

function getCurrentUser() {
  if(!User){
    User=parseJWT(getJwt());
  }
  log.debug(' authCentral:getCurrentUser: USER IS ',User);
  return User;
}

const authCentral = {
  setTokenKeyName,
  setOauth,
  localLogout,
  getCurrentUser,
  logoutWithoutRedirect,
  loadJWTFromServer
};

export default authCentral;
